import ApiInstance from '@/api/instance'
import { ITodoResponse } from '@zunta/configurations'

export default class TodoApi {
  instance: ApiInstance

  constructor (instance: ApiInstance) {
    this.instance = instance
  }

  async getTodoList (filters: any): Promise<ITodoResponse> {
    return this.instance.doGet(`/user/todoList`, filters)
  }
}
